import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { LoginQueryModel } from "src/app/components/Shared/Model/login";
import { LoginService } from "src/app/components/Shared/Service/login_service";
import { AuthStatus } from "src/app/components/Shared/Model/AuthStatus";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DashboarduiService } from "../Shared/Service/dashboardui.service";
import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  providers: [LoginService],
})

export class LoginComponent implements OnInit {
  isProgressing: Boolean = false;
  public loginQueryModel: LoginQueryModel;
  public lstAuth: any = ([] = []);
  public hotellist: AuthStatus[] = [];
  yearBindingDynamic = new Date().getFullYear()
  public userId: string;
  public User: string;
  isIDSUser: boolean;
  Login: boolean = false;
  forgotpwd: boolean = false;
  hide: boolean = false;
  loginForm: any;
  password: any;
  invaildErrorMsgEmail: any;
  invaildErrorMsgPwd: any;
  resetPwdFormValidation: boolean = false;
  forgotPwdDisplay: boolean = false;
  resetPwdForm: FormGroup | any;
  forgotEmailId: any;
  invaildErrorMsgForgotEmail:any
  changePwdDisplayContent: boolean = false;
  
  oldPassword: any;
  errorMsg: any;
  newPassword: any;
  confirmNewPassword: any;
  changePwdForm: FormGroup | any;
  changePwdFormValidation: boolean = false;
  changeOldPasswordhide: boolean = false;
  newPasswordHide: boolean = false;
  confirmNewPasswordHide = false
  constructor(private route: Router, private formBuilder: FormBuilder, private _APISERVICE: LoginService,
    private apiCallIdsService: DashboarduiService,private toastr: ToastrService
  ) {
    this.loginQueryModel = new LoginQueryModel();
    this.userId = this.loginQueryModel.userId;
    // this.userId = this.loginQueryModel.UserId;
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required]],/* Validators.pattern('^[0-9a-zA-Z]+$') */
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }
  ngOnInit() {
    console.log('login enter')
    console.log('yearBindingDynamic = ', this.yearBindingDynamic)
    this.changePwdForm = this.formBuilder.group({
      newPassword: ['', [Validators.minLength(6)]]
    });
    this.resetPwdForm = this.formBuilder.group({
      forgotPwdEmailID: ['', [Validators.required]],
    });
  }
  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService
      .getfootfall(this.User, "LOGIN", "dashboard")

      .subscribe((data) => {
        //alert('Footfall= '+data)
      });
  }
  @Output()  IsloginChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  login() {
    this.Login = true;
    if (this.loginForm.invalid) {
      console.log('if')
      return;
    }
    else {
      this.userId = this.loginForm.value.username
      console.log('Login Email ID = ', this.userId)
      localStorage.setItem("Username", this.userId);
      this.password = this.loginForm.value.password;
      console.log('Login password = ', this.password)
      this.isIDSUser = this._APISERVICE.isIDSUser();
      console.log('condition check = ', this.isIDSUser)
      if (this.isIDSUser) {
        this.apiCallIdsService.isLogin(this.userId, this.password)
          .subscribe(
            data => {
              console.log('Res Data = ', data[0].status)
              if (data[0].status == 'Invalid User ID') {
                console.log(data[0].status)
                this.invaildErrorMsgEmail = "Invalid Email ID"
                setTimeout(() => {
                  this.invaildErrorMsgEmail = ""
                }, 3000);
              }
              else if (data[0].status == 'Invalid Password') {
                console.log(data[0].status)
                this.invaildErrorMsgPwd = data[0].status
                setTimeout(() => {
                  this.invaildErrorMsgPwd = ""
                }, 3000);
              }
              else if (data[0].status == 'You are restricted to access the Dashboard') {
                console.log(data[0].status)
                this.toastr.error(data[0].status);
                /* this.invaildErrorMsgPwd = data[0].status
                setTimeout(() => {
                  this.invaildErrorMsgPwd = ""
                }, 3000); */
              }
              else {
                if (data[0].status == 'Success' && data[0].isOldUser == 'YES') {
                  console.log(data[0].status)
                  this.IsloginChange.emit(true);
                  return this.route.navigate(["/dashboard"]);
                } else {
                  this.changePwdPopup()
                }
              }
            }
          )
      } else {
        this.invaildErrorMsgEmail = "Invalid Email ID (This portal is only for IDS Users)."
        // this.toastr.error('This portal is only for IDS Users.')
        setTimeout(() => {
          this.invaildErrorMsgEmail = ""
        }, 4000);
      }
    }
  }

  forgotPwd(){
    this.forgotPwdDisplay = true;
  }
  submitForgotPwd(){
    this.resetPwdFormValidation = true;
    if (this.resetPwdForm.invalid) {
      console.log('if')
      return;
    }else{
      this.forgotEmailId = this.resetPwdForm.value.forgotPwdEmailID
      console.log('forgot Email ID = ', this.forgotEmailId)
      this.apiCallIdsService.forgotPasswordReqPayload(this.forgotEmailId)
      .subscribe(
        data => {
          console.log('Res Data = ', data)
          if (data[0].Status == 'Error' && data[0].StatusDescription == 'Invalid UserName') {
            this.toastr.error("Invalid Email ID", "", {
              timeOut: 3000
            });
          }
          else if(data[0].Status == 'Success'){
            this.forgotPwdDisplay = false;
            this.toastr.success(data[0].StatusDescription, "", {
              timeOut: 5000
            });
          }
        }
      )
    }
  }
  closeForgotPwdPopup() {
    this.forgotPwdDisplay = false
  }

  changePwdPopup() {
    this.changePwdDisplayContent = true
  }
  closeChangePwdPopup() {
    this.changePwdDisplayContent = false
  }

  submitChangePwd() {
    if (this.oldPassword == '' || this.oldPassword == undefined || this.oldPassword == null) {
      this.errorMsg = "Please enter old password"
      setTimeout(() => {
        this.errorMsg = ""
      }, 2500);
    }
    else if (this.oldPassword != '') {
      if (this.oldPassword != this.password) {
        this.errorMsg = "Invalid Old Password"
        setTimeout(() => {
          this.errorMsg = ""
        }, 2500);
      } else if (this.oldPassword == this.password) {
        if (this.newPassword == '' || this.newPassword == undefined || this.newPassword == null) {
          this.errorMsg = "Please enter new password"
          setTimeout(() => {
            this.errorMsg = ""
          }, 2500);
        } else if (this.confirmNewPassword == '' || this.confirmNewPassword == undefined || this.confirmNewPassword == null) {
          this.errorMsg = "Please enter same password as above"
          setTimeout(() => {
            this.errorMsg = ""
          }, 2500);
        }
        else {
          if (this.confirmNewPassword != this.newPassword) {
            this.errorMsg = "New and confirm new password should be same"
            setTimeout(() => {
              this.errorMsg = ""
            }, 2500);
          } else {
            this.changePwdFormValidation = true
            if (this.changePwdForm.invalid) {
              console.log('invalid')
              return;
            }
            else {
              let changePwdPayload = {
                "USERID": this.userId,
                "OLDPASSWORD": this.oldPassword,
                "NEWPASSWORD": this.newPassword
              }
              console.log('changePwdPayload', changePwdPayload)
              this.apiCallIdsService.changePassword(changePwdPayload)
                .subscribe((data: any) => {
                  console.log('changePassword =', data)
                  if (data[0].Status == 'Success') {
                    this.changePwdDisplayContent = false
                    this.toastr.success(data[0].StatusDescription, "", {
                      timeOut: 2500
                    });
                    setTimeout(() => {
                      window.location.reload()
                    }, 3000);
                  } else {
                    this.toastr.error(data[0].StatusDescription, "", {
                      timeOut: 2500
                    });
                  }

                });
            }
          }
        }
      }
    }

  }
  passwordChecks = {
    hasLower: false,
    hasUpper: false,
    hasNumber: false,
    hasSpecial: false,
    hasExactLength: false,
  };
    strengthBarWidth = '0%';
strengthText = '';
strengthColor = 'red';
allRulesPassed = false;
checkPasswordStrength() {
  const pswd =this.newPassword || '';

  this.passwordChecks.hasLower = /[a-z]/.test(pswd);
  this.passwordChecks.hasUpper = /[A-Z]/.test(pswd);
  this.passwordChecks.hasNumber = /[0-9]/.test(pswd);
  this.passwordChecks.hasSpecial = /[!@#$%^&*]/.test(pswd);
    this.passwordChecks.hasExactLength = pswd.length >= 8;

  const passedCount = Object.values(this.passwordChecks).filter(v => v).length;

  if (passedCount <= 2) {
    this.strengthText = 'Weak';
    this.strengthColor = 'red';
    this.strengthBarWidth = '30%';
  } else if (passedCount === 3 || passedCount === 4) {
    this.strengthText = 'Average';
    this.strengthColor = 'orange';
    this.strengthBarWidth = '70%';
  } else if (passedCount === 5) {
    this.strengthText = 'Strong';
    this.strengthColor = 'green';
    this.strengthBarWidth = '100%';
  }
  this.allRulesPassed =
    this.passwordChecks.hasLower &&
    this.passwordChecks.hasUpper &&
    this.passwordChecks.hasNumber &&
    this.passwordChecks.hasSpecial &&
    this.passwordChecks.hasExactLength;

}


}
